import { Component, Input, SimpleChanges } from '@angular/core';
import { SecondaryStats } from '@athleticnet/athletic-live-api-models/lib/models/shared/secondary-stats.interface';
import { CurrentMeetService } from 'src/app/shared/services/current-meet.service';

@Component({
  selector: 'app-secondary-stats',
  templateUrl: './secondary-stats.component.html',
  styleUrls: ['./secondary-stats.component.scss'],
  standalone: true,
})
export class SecondaryStatsComponent {
  @Input() result!: SecondaryStats;
  statLine: string = '';

  constructor(private currentMeetService: CurrentMeetService) {}

  ngOnInit() {
    this.populateStatLine();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['result'] && !changes['result'].isFirstChange()) {
      this.populateStatLine();
    }
  }

  populateStatLine() {
    const statsString = [];
    const showConversions = this.currentMeetService.meet?.showConversions ?? true;
    if (this.result) {
      if (this.result.conversion && showConversions) {
        statsString.push(this.result.conversion);
      }
      if (this.result.notes) {
        statsString.push(this.result.notes);
      }
      // TODO: Needed for field dashboard
      // if (this.result.bestMark && this.result.bestMark.conversion && showConversions) {
      //   statsString.push(this.result.bestMark.conversion);
      // }

      if (statsString.length > 0) {
        this.statLine = statsString.join(' • ');
      } else {
        this.statLine = '';
      }
    }
  }
}
